import { RJSFSchema } from "@rjsf/utils";

export const achFormSchema: RJSFSchema = {
  type: "object",
  "x-logo": "/657507_tmpl_head_60db3e2024ea6.png",
  title: "ACH Premium Payment Authorization Agreement / Direct Deposit Form for Commissions",
  required: ["achType"],
  properties: {
    instructions: {
      type: "null",
      title: "",
    },
    achType: {
      type: "string",
      title:
        "Is this for ACH Premium Payment Authorization or Direct Deposit for Commissions? (PLEASE SEE SUPPORTING TEXT BELOW)",
      enum: [
        "ACH Premium Payment Authorization for Groups",
        "Broker Commission Payment Setup",
        "ACH Premium Payment for COBRA Member",
      ],
    },
    optionNote: {
      type: "null",
      title:
        "**NOTE: If you are a group submitting ACH Debit information for premium payments, PLEASE SELECT OPTION 1. If you are an agent/broker setting up commission payments to your company, PLEASE SELECT OPTION 2.",
    },
    typeOfTransaction: {
      type: "string",
      title: "A. Type of Transaction*",
      enum: ["Add", "Change", "Delete"],
    },
    monthlyOrOneTimePull: {
      type: "string",
      title: "Monthly or One-Time Pull?*",
      enum: ["Monthly", "One-Time"],
    },
    submittedOneTimePayment: {
      type: "string",
      title: "Have you submitted a one-time payment previously to pay your invoice? *",
      enum: ["Yes", "No"],
    },
    usePreviousBankInfo: {
      type: "string",
      title: "Would you like to use previously submitted bank information?*",
      enum: ["Yes", "No", "I have submitted previously but don't know what banking information I supplied"],
    },
    employerBrokerMember: {
      type: "string",
      title: "Are You the Employer, Broker, or Member?*",
      enum: ["Employer", "Broker", "Member"],
    },
    nameOfCompany: {
      type: "string",
      title: "Name of Company *",
    },
    groupNumber: {
      type: "string",
      title: "Group Number *",
    },
    location: {
      type: "string",
      title: "Location",
      description:
        "Please enter the location name or number for all locations that apply if paying for individual locations seperately. Leave blank if paying for the group as a whole.",
    },
    nameOfBrokerOnRecord: {
      type: "string",
      title: "Name of Broker on Record*",
    },
    nameOfCobraMember: {
      type: "string",
      title: "Name of COBRA Member *",
    },
    brokerName: {
      type: "string",
      title: "Name of Broker on Record*",
    },
    commissionsPayableTo: {
      type: "string",
      title: "Will commissions be payable to an Individual Agent or an Agency?*",
      enum: ["Individual Agent", "Agency"],
    },
    brokerGroupNumber: {
      type: "string",
      title: "Group Number *",
    },
    addressLine1: {
      type: "string",
      title: "Address Line 1",
    },
    addressLine2: {
      type: "string",
      title: "Address Line 2",
    },
    city: {
      type: "string",
      title: "City",
    },
    state: {
      type: "string",
      title: "State",
      enum: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    },
    zipCode: {
      type: "string",
      title: "ZIP Code",
    },
    taxId: {
      type: "string",
      title: "Tax ID*",
    },
    email: {
      type: "string",
      title: "Email address for banking and general correspondence communications.*",
      format: "email",
    },
    w9Instruction: {
      type: "null",
      description:
        "Please attach signed W-9 matching Tax ID - Please have Field 1, 2 (if applicable), 5, 6 and Part 1 of the W-9 filled out (IF COMMISIONS ARE BEING PAID TO THE AGENCY THEN EMPLOYER ID. IF AGENT THEN SS) *",
    },
    w9FileUpload: {
      type: "string",
      title: "W-9 Upload",
      description: "Accepted formats: PDF, PNG, JPG, JPEG.",
      format: "data-url",
    },
    financialInstitutionName: {
      type: "string",
      title: "Financial Institution Name*",
    },
    fiAddressLine1: {
      type: "string",
      title: "Financial Institution Address Line 1",
    },
    fiAddressLine2: {
      type: "string",
      title: "Financial Institution Address Line 2",
    },
    fiCity: {
      type: "string",
      title: "Financial Institution City",
    },
    fiState: {
      type: "string",
      title: "Financial Institution State",
      enum: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    },
    fiZipCode: {
      type: "string",
      title: "Financial Institution ZIP Code",
    },
    accountType: {
      type: "string",
      title: "B. Type of account*",
      enum: ["Savings", "Checking"],
    },
    routingNumber: {
      type: "string",
      title: "Transit Routing / ABA Number*",
    },
    accountNumber: {
      type: "string",
      title: "Account Number at Above Institution*",
    },
    oneTimeAmount: {
      type: "string",
      title: "Payment Amount (for one time ACH)*",
    },
    authorizationText: {
      type: "null",
      title: "",
    },
    bankingDocInstruction: {
      type: "null",
      description:
        "Please attach a voided check for a checking account or a Banking Letter from your financial institution for a savings account. The name on the check must match the name on the W9 form*",
    },
    bankingDocumentUpload: {
      type: "string",
      title: "Banking Document Upload",
      description: "Accepted formats: PDF, PNG, JPG, JPEG.",
      format: "data-url",
    },
    date: {
      type: "string",
      title: "Date*",
      format: "date",
    },
    typedSignature: {
      type: "string",
      title: "Typed Signature*",
    },
  },
};
